module.exports = __webpack_public_path__ + "media/images/desktop-disneyland-15e3a020d35d4caf1f8febaf77f4b3bf.jpg";